import { Select } from "antd";
import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector } from "../../../../../../util/store/store";
import { cloneObj, renderOpts } from "../../../../../../util/varibles/global";
import { IFactory, TOperation } from "../../../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../../../util/varibles/message";
import { selectPlan } from "../../../../constants";
import { checkRoute } from "../../../../util";
import { useEditOp } from "../../EditOperationContext";
import { DELIVERY_UNIT } from "../../Harvest/constants";
import { ErrorName } from "../ErrorOfOperation";

interface IProps {
    data: TOperation

    onChange(value: Partial<TOperation>): void
}

const Factory: React.FC<IProps> = ({ data, onChange }) => {
    const [factories] = useEditOp(state => state.factories);
    const { sites = [], sub_operations = [], factory_id } = data;
    const error_detail = cloneObj(data?.error_detail || {});
    const notifyRef = useRef<{ deliveryTypes: boolean }>({ deliveryTypes: false });
    const routeIds = useSelector(selectPlan.routeIds);
    const error = useRef(error_detail);
    useEffect(() => {
        error.current = error_detail;
    }, [error_detail])

    const handleChange = useCallback((value: IFactory) => {
        let isRoute = false;
        const newSites = sites.map((sub) => {
            const { error } = checkRoute(sub, value, routeIds);
            if (error !== 2) {
                isRoute = true;
                return { ...sub, isRoute: true }
            }
            return { ...sub, isRoute: false }
        })
        if (!isRoute) {
            error.current[ErrorName.Route] = sites.map(item => ({
                source_id: item.id,
                destination_id: value.id,
                message: notify[NotifyCode.E20]([item.name, value.name])
            }));
        } else {
            delete error.current[ErrorName.Route];
        }
        const { deliver_type } = value;
        const result: Partial<TOperation> = {
            factory_id: value.id,
            sites: newSites,
            factory_name: value.name,
            error_detail: error.current,
        }
        const deliveryTypeKey = Object.keys(deliver_type).find(key => deliver_type[key].default) || Object.keys((deliver_type || {}))[0];
        if (deliveryTypeKey) {
            if (notifyRef.current.deliveryTypes) {
                notifyRef.current.deliveryTypes = false;
                notify.warn(NotifyCode.W8)();
            }
            const { id, name, type } = deliver_type[deliveryTypeKey];
            result.sub_operations = sub_operations.map(item => {
                const { fish_amount, total_weight, delivery_types = [], unit_id } = item;
                const { unit = DELIVERY_UNIT.TONS } = delivery_types[0];
                return {
                    ...item,
                    delivery_types: [{ fish_amount, total_weight, id, unit, unit_id, tanks: [], name, type }]
                }
            });
        } else {
            notify.error(NotifyCode.E45)([value.name]);
            result.sub_operations = sub_operations.map(item => ({
                ...item,
                fish_amount: 0,
                total_weight: 0,
                delivery_types: []
            }));
            result.total_weight = 0;
            result.total_amount = 0;
            result.fish_amount = 0;
        }

        onChange(result)
    }, [sites, onChange, routeIds, sub_operations]);

    useEffect(() => {
        if (error.current[ErrorName.Route] && routeIds.length > 0) {
            let isRoute = false;
            const newSites = sites.map((sub) => {
                const { error } = checkRoute(sub, { id: factory_id, name: "" }, routeIds);
                if (error !== 2) {
                    isRoute = true;
                    return { ...sub, isRoute: true }
                }
                return { ...sub, isRoute: false }
            })
            if (isRoute) {
                delete error.current[ErrorName.Route];
                onChange({
                    sites: newSites,
                    error_detail: error.current
                })
            }
        }
    }, [routeIds, factory_id, sites, onChange])

    return <Select
        value={factory_id}
        variant={"borderless"}
        popupMatchSelectWidth={false}
        onSelect={(_, option: { root: IFactory }) => handleChange(option.root)}
        options={renderOpts<IFactory>(factories)}
    />
};

export default Factory;